import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

import {
  CLEAR_FLASH_MESSAGE,
  CLEAR_PROMISE,
  CLEAR_TEMP_NUM_RESULTS,
  PUSH_FLASH_MESSAGE,
  SET_COUNTRY_CODE,
  SET_DNS_ENVIRONMENT,
  SET_LANGUAGE_CODE,
  SET_MODULES_ENVIRONMENT,
  SET_PROMISE,
  SET_TOP_LEVEL_ZONE,
  TOGGLE_FAVOURITE,
  UPDATE_FAVOURITE,
  UPDATE_NUM_RESULT,
} from "@/store/types/mutations";

import { POPULATED_TOP_LEVEL_ZONE, STAGE } from "@/app.config";

const defaultStageToUse = STAGE === "local" ? "test" : STAGE;

export default new Vuex.Store({
  state: {
    _promises: {},
    favourites: [],
    flashMessages: [],
    numResults: {
      persisted: {},
      temp: {},
    },
    settings: {
      countryCode: "us",
      dnsEnvironment: defaultStageToUse,
      languageCode: "en",
      modulesEnvironment: defaultStageToUse,
      topLevelZone: POPULATED_TOP_LEVEL_ZONE,
    },
  },
  getters: {
    getCachedNumResult: state => numUriString => {
      return (
        state.numResults.persisted[numUriString] ||
        state.numResults.temp[numUriString]
      );
    },
  },
  mutations: {
    [CLEAR_FLASH_MESSAGE](state, index) {
      state.flashMessages.splice(index, 1);
    },
    [CLEAR_PROMISE](state, key) {
      delete state._promises[key];
    },
    [CLEAR_TEMP_NUM_RESULTS](state) {
      Vue.set(state.numResults, "temp", {});
    },
    [PUSH_FLASH_MESSAGE](state, { cta, message, persist }) {
      state.flashMessages.push({ cta, message, persist });
    },
    [SET_COUNTRY_CODE](state, countryCode) {
      Vue.set(state.settings, "countryCode", countryCode);
    },
    [SET_DNS_ENVIRONMENT](state, dnsEnvironment) {
      Vue.set(state.settings, "dnsEnvironment", dnsEnvironment);
    },
    [SET_LANGUAGE_CODE](state, countryCode) {
      Vue.set(state.settings, "languageCode", countryCode);
    },
    [SET_MODULES_ENVIRONMENT](state, modulesEnvironment) {
      Vue.set(state.settings, "modulesEnvironment", modulesEnvironment);
    },
    [SET_PROMISE](state, { key, promise }) {
      Vue.set(state._promises, key, promise);
    },
    [SET_TOP_LEVEL_ZONE](state, countryCode) {
      Vue.set(state.settings, "topLevelZone", countryCode);
    },
    [TOGGLE_FAVOURITE](state, numUriString) {
      const isAlreadyFav = state.favourites.some(
        f => f.numUriString === numUriString,
      );
      let updatedFavourites;

      if (isAlreadyFav) {
        updatedFavourites = state.favourites.filter(
          f => f.numUriString !== numUriString,
        );
      } else {
        updatedFavourites = [...state.favourites, { numUriString }];
      }

      Vue.set(state, "favourites", updatedFavourites);
    },
    [UPDATE_FAVOURITE](state, { numUriString, results }) {
      const numUriFavIndex = state.favourites.findIndex(
        f => f.numUriString === numUriString,
      );
      const numUriFav = state.favourites[numUriFavIndex];
      const updatedFavourite = {
        ...numUriFav,
        results: {
          ...numUriFav.results,
          ...results,
        },
      };
      state.favourites[numUriFavIndex] = updatedFavourite;
    },
    [UPDATE_NUM_RESULT](
      state,
      { numUriString, persisted, populated, result, storedOn },
    ) {
      const type = persisted ? "persisted" : "temp";
      state.numResults[type][numUriString] = {
        populated,
        result,
        storedOn,
      };
    },
  },
  actions: {},
  plugins: [
    createPersistedState({
      key: "num-contacts-app",
      paths: ["favourites", "numResults.persisted", "settings"],
    }),
  ],
});
